console.clear()
var pym = require("./lib/pym");
var pymChild = null;

var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");

// check if this user has set "prefers reduced motion" in their browser
// https://since1979.dev/respecting-prefers-reduced-motion-with-javascript-and-react/
const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

var itemVisible = function(e) {
  e.forEach((item, i) => {
    if (item.isIntersecting) {
      item.target.classList.add("active");
      item.target.classList.remove("inactive");

    } else {
      // item.target.classList.remove("active");
      // item.target.classList.add("inactive");
    }
  });
  pymChild.sendHeight();
}

var onResize = function() {
  pymChild.sendHeight();
}

pym.then(child => {
    pymChild = child;    

    // show items when they're visible onscreen
    // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
    if (!reducedMotion.matches) {
      let observer = new IntersectionObserver(itemVisible, { threshold: 0.5 });
      var items = document.querySelectorAll(".graphic tr");
      items.forEach((item, i) => {
        item.classList.add("inactive");
        observer.observe(item);
      });
    } else {
      var items = document.querySelectorAll(".graphic tr");
      items.forEach((item, i) => {
        item.classList.add("active");
      });
    }

    const markers = document.querySelectorAll('.marker');
    
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: Array.from({ length: 101 }, (_, i) => i / 100)
    };

    let lowestVisible = 0;
    let visibleItems = []

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const index = parseInt(entry.target.getAttribute('data-index'));
        if (entry.isIntersecting) {
          // add intersecting entry            
          visibleItems.push(index)            
        } else {            
          // remove exiting entries
          visibleItems = visibleItems.filter(n => n !== index)
        }

        lowestVisible = Math.min(...visibleItems)
        document.getElementById("static-container").style.top = `${lowestVisible}%`;
      });
    }, observerOptions);

    markers.forEach(marker => observer.observe(marker));

    // add the icons
    const spans = document.querySelectorAll('tr.con .desc span:not(.conButton)');
    spans.forEach(span => iconCreation(span))

    const sideBar = document.querySelectorAll('#static-container .key-group span');
    sideBar.forEach(span => iconCreation(span))

    pymChild.sendHeight();
    window.addEventListener("resize", onResize);
});

var iconCreation = function(span) {
  const template = document.createElement('template');
  const icon = `<img alt='icon' src='img/icons/${span.classList[0].toLowerCase()}.svg'>`;
  template.innerHTML = icon.trim();

  let wrapperSpan = document.createElement('span');
  span.parentNode.insertBefore(wrapperSpan, span);
  wrapperSpan.appendChild(span);
  wrapperSpan.classList.add("icon-wrapper")

  span.before(template.content.firstChild);
}
